/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Button } from '../../CommonComponents/OPL/Button/Button';
import { Text } from '../../CommonComponents/OPL/Text/Text';

interface TermsProps {
  onSave(): void;
}

export const Terms: React.FC<TermsProps> = ({ onSave }) => (
  <Box width="100%" display="flex" flexDirection="column" alignItems="center">
    <Box
      height="400px"
      p="16"
      mb="32"
      border="1px solid #ccc"
      borderRadius="medium"
      bg="#eee"
      color="#333"
      overflow="auto"
    >
      <Text as="h6" textAlign="center" fontSize="h6" fontWeight={600} color="neutral.500" mb="32">
        Service Agreement
      </Text>
      <Text my="16">
        This Application Services Agreement (the "Agreement") is made and entered into as of the
        Master Effective Date by and between ADVIZR, INC., A DELAWARE CORPORATION ("Advizr") and the
        entity listed as Customer in the table above.
      </Text>
      <Text my="16">
        A. Advizr offers a software-as-a-service offering (the "Application Services") designed to
        enable Customer to scaleably provide financial planning services for Advisee's, and
      </Text>
      <Text my="16">B. Customer desires to purchase the Advizr Services.</Text>
      <Text my="16">
        For the good and valuable consideration set forth herein, the parties agree as follows:
      </Text>
      <Text my="16">1. DEFINITIONS</Text>
      <Text my="16">
        1.1 "Advisees" means inTextiduals that are party to a written agreement with Customer
        pursuant to which Customer provides financial planning services on such inTextidual's
        behalf. Advisees may have limited access to the Application Services.
      </Text>
      <Text my="16">
        1.2 "Authorized User(s)" means Customer's employees, contractors and Advisees who are
        authorized by Customer to access the features and functions of the Application Services.
      </Text>
      <Text my="16">
        1.3 "Customer Data" means the information and data provided to Advizr by Authorized Users
        through the Application Services.
      </Text>
      <Text my="16">
        1.4 "Fee" means the fee specified in the Order Form for the applicable services.
      </Text>
      <Text my="16">1.5 "Initial Term" has the meaning set forth in Paragraph 3.1 ("Term").</Text>
      <Text my="16">
        1.6 "Order Form" means Advizr's standard form of ordering document pursuant to which
        Services are ordered by Customer subject to the terms and conditions of this Agreement,
        which must be approved by Advizr to be effective.
      </Text>
      <Text my="16">
        1.7 "Professional Services" means the development or consulting services ordered by Customer
        pursuant to an Order Form.
      </Text>
      <Text my="16">
        1.8 "Services" mean any services provided by Advizr pursuant to this Agreement including the
        Application Services, Professional Services and related other services like technical
        support services
      </Text>
      <Text my="16">2. ACCESS GRANTS; PERFORMANCE OF SERVICES; AND OWNERSHIP</Text>
      <Text my="16">
        2.1 Provision of Services. Subject to the terms and conditions of this Agreement, Advizr
        will provide the Services ordered pursuant to any Order Form to Customer in a workmanlike
        and professional manner in accordance with industry standards.
      </Text>
      <Text my="16">
        2.2 Access Protocols; Authorized Users. Advizr will promptly after accepting an Order Form
        provide
      </Text>
      <Text my="16">
        Customer the Access Protocols. Customer will: (a) safeguard the Access Protocols and ensure
        that Authorized Users safeguard the Access Protocols; (b) make Authorized Users aware of the
        Customer's obligations under this Agreement, and (c) be responsible for all acts and
        omissions of Authorized Users.
      </Text>
      <Text my="16">
        2.3 Right of Access; Limitation on Number of Concurrent Users. Subject to terms and
        conditions of this Agreement and Advizr's acceptance of an applicable Order Form, Advizr
        grants to Customer a non-exclusive, non-transferable right during the Term to allow
        Authorized Users to access the Application Services solely for the purpose of developing
        financial plans on behalf its Advisees. Customer's right to access the Application Services
        is limited to the number of Authorized Users listed in the applicable Order Form(s).
      </Text>
      <Text my="16">
        2.4 Customer Data. Use of the Application Services will permit or require Customer to
        provide Customer Data to Advizr for purposes of processing, analyzing and storing such
        Customer Data and otherwise performing the Services. Customer hereby grants to Advizr a
        limited license: (a) during the Term to use, copy, display, disclose, modify and distribute
        the Customer Data solely for the purpose of providing the Services and (b) on a perpetual
        basis, to use, copy, display, disclose, modify and distribute the Customer Data solely to
        create and compile aggregated data and/or statistics; provided, however, in any such
        aggregated data or statistics, Advizr will ensure that the Customer Data is used in
        aggregated form only and in a manner that is not directly attributable to or identified with
        Customer or its Advisees. Advizr will use appropriate administrative, physical and technical
        safeguards to protect sensitive Customer Data, including, as appropriate, encryption
        technology.
      </Text>
      <Text my="16">
        2.5 Restrictions on Use. Customer will not: (a) modify, adapt, alter, translate or create
        derivative works of the Services, including the Application Services; (b) sublicense, lease,
        rent, loan or otherwise transfer Customer's rights hereunder (except in connection with an
        assignment of Customer's rights permitted under Section 12.3 ("Assignment") to any third
        party; (c) reverse engineer, decompile, disassemble, or otherwise attempt to derive the
        human readable, source code version of the Application Services or the technology underlying
        the Application Services; (d) publish or post false or misleading information about Advizr;
        (e) remove any proprietary notices of Advizr or third parties found on, in or in association
        with the Services; (f) publish any performance or benchmark tests or analysis relating to
        the Services, including the use thereof, without the approval of Advizr; (g) use the
        Services in any way that infringes any third party intellectual property right, breaches the
        terms of any agreement between Customer and any third party or violates applicable law.
      </Text>
      <Text my="16">
        2.6 Advisee Agreement. Customer acknowledges that prior to accessing the Application
        Services, Advisees may be required to enter into an end user license agreement that includes
        a disclaimer that Advizr is not liable for any decisions, acts or omissions of the Advisee
        based upon any financial plan developed by Customer.
      </Text>
      <Text my="16">
        2.7 Ownership. Advizr retains all right, title and interest in the Services, including the
        Application Services, and all intellectual property rights therein. All rights not expressly
        granted by Advizr is reserved. Customer retains all right, title and interest in the
        Customer Data and all intellectual property rights therein. All rights not expressly granted
        by Customer is reserved.
      </Text>
      <Text my="16">
        2.8 Feedback. Advizr may request that Customer provide feedback regarding the use, operation
        and functionality of the Services ("Feedback"), which Customer will provide at its
        discretion. Feedback will include any information about operating results, known or
        suspected bugs, errors or compatibility problems and user-desired features. Customer agrees
        that Advizr, without any compensation to Customer, will have an irrevocable right to use the
        Feedback and related information in any manner it deems appropriate.
      </Text>
      <Text my="16">3. TERM AND TERMINATION.</Text>
      <Text my="16">
        3.1 Term. The term of this Agreement will commence on the Date of the Customer's signature
        and will continue for as long as any Order Form is in effect, unless terminated in
        accordance with this Section or as otherwise expressly provided in this Agreement (the
        "Term").
      </Text>
      <Text my="16">
        3.2 Termination for Material Breach. Either party may terminate this Agreement or any Order
        Form, at its discretion, effective immediately upon written notice to the other if the other
        party materially breaches any provision of this Agreement and does not substantially cure
        the breach within thirty (30) days after receiving written notice.
      </Text>
      <Text my="16">
        3.3 Suspension of Service(s). At any time during the Term, Advizr may, immediately upon
        notice to Customer, suspend access to any Service, at its discretion, including a threat to
        the technical security or technical integrity of the Services or any amount due under this
        Agreement is not received by Advizr within fifteen (15) days of the due date.
      </Text>
      <Text my="16">
        3.4 Termination upon Bankruptcy or Insolvency. Advizr may, at its option, terminate this
        Agreement immediately upon written notice to Customer, in the event (a) that Customer
        becomes insolvent or unable to pay its debts when due; (b) Customer files a petition in
        bankruptcy, reorganization or similar proceeding, or, if filed against, such petition is not
        removed within ninety (90) days after such filing; (c) Customer discontinues its business;
        or (d) a receiver is appointed or there is an assignment for the benefit of Customer's
        creditors.
      </Text>
      <Text my="16">
        3.5 Termination for Convenience. Advizr may terminate any Order Form and this Agreement at
        any time at its convenience upon no less than thirty (30) days notice. In the event of any
        such termination, Advizr will refund to Customer any prepaid, but unused fees, on a
        straight-line, pro-rata basis, based on a 365 day year.
      </Text>
      <Text my="16">
        3.6 Effects of Termination. Upon termination or expiration of this Agreement for any reason:
        (a) any amounts owed to Advizr before such termination or expiration will be immediately due
        and payable; and (b) all access rights granted will immediately cease to exist. The
        following provisions will survive termination: Sections 1 ("Definitions"), 3 ("Term and
        Termination"), 4 ("Warranties, Disclaimers and Limitations on Damages"), 5 ("Indemnity"), 6
        ("Confidential Information"), 7 ("Payment Terms") and 8 ("Miscellaneous") of this Agreement
        will survive any termination or expiration of this Agreement.
      </Text>
      <Text my="16">4. WARRANTIES, DISCLAIMERS AND LIMITATION ON DAMAGES</Text>
      <Text my="16">
        4.1 General Representations. Each party hereby represents and warrants: (a) that it is duly
        organized, validly existing and in good standing under the laws of its jurisdiction of
        incorporation or organization; (b) that the execution and performance of the Agreement will
        not conflict with or violate any provision of any law having applicability to such party;
        and (c) that the Agreement, when executed and delivered, will constitute a valid and binding
        obligation of such party and will be enforceable against such party in accordance with its
        terms.
      </Text>
      <Text my="16">
        4.2 General Disclaimers. EXCEPT AS EXPRESSLY PROVIDED IN THE AGREEMENT, INCLUDING ANY
        SCHEDULE, NEITHER PARTY MAKES ANY WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
        STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTY OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, QUIET ENJOYMENT
        OR FROM A COURSE OF DEALING OR USAGE IN TRADE. ADVIZR DOES NOT WARRANT, AND SPECIFICALLY
        DISCLAIMS, THAT THE SERVICES WILL BE ACCURATE, SECURE, WITHOUT INTERRUPTION, OR ERROR-FREE.
      </Text>
      <Text my="16">
        4.3 Use; Decision Support Disclaimer. Customer acknowledges that the Application Services
        are provided to Customer and its Authorized Users as a decision support tool to aid in its
        financial planning business. Customer agrees that Customer will not rely solely on the
        output of the Application Services and that Customer and its Authorized Users will rely on
        their professional judgment in providing any financial planning services to any Advisee.
        Customer is solely responsible for (i) Customer's and its Authorized Users' use of the
        Services, including the Application Services and the Professional Services and (ii) any
        decision Customer or Advisees make, in whole or in part, therefrom, including any trades and
        investment decisions or strategies. Customer further agrees that Advizr will not be
        responsible for any loss or damage to Customer, its Authorized Users, or any Advisees caused
        by the failure of the Application Services or any error or data produced or derived
        therefrom.
      </Text>
      <Text my="16">
        4.4 No Professional Advice. Advizr is not engaged in rendering any investment, trading or
        other professional advice. If investment, trading or other professional advice is required,
        the services of a competent, licensed professional should be sought. No employee, agent or
        representative of Advizr is authorized to provide any such advice of any nature whatever,
        and any such advice, if given, is in violation of Advizr's policies, is unauthorized and may
        not be relied upon.
      </Text>
      <Text my="16">
        4.5 No Guaranteed Results. THE SERVICES ARE NOT GUARANTEED TO ACHIEVE ANY PARTICULAR
        RESULTS. The use of any trading system or strategy, including any system or strategy
        integrated within the Services, does not and cannot guarantee that Customer or Advisees will
        make profits, increase profits or minimize losses.
      </Text>
      <Text my="16">
        4.6 Customer is Solely Responsibility for Input Correctness and Accuracy: The quality of the
        product's analysis and optimization depends on the Authorized User's inputs. While automated
        guidance and value generation has been made available in the product to ease and expedite
        entry of the parameters required for the product's analysis and optimization, Customer and
        its Authorized Users are solely responsible for ensuring the quality of all its inputs. As
        such, you must carefully review and update all input parameters and modify their values in
        all ways necessary to ensure their accuracy and fidelity. While there are other factors
        governing analysis and optimization accuracy, the quality of the product outputs depends on
        the accuracy of your inputs.
      </Text>
      <Text my="16">
        4.7 Beta Feature Disclaimers: Any input, feature of function marked "Alpha", "Beta" or
        similar designation invokes a Beta version of the Applications Services. The Beta version is
        intended for the sole purpose of obtaining product feedback from the product's future
        customers, and Advizr's partners. Accordingly, these additional terms and disclaimers apply
        to any Beta service.
      </Text>
      <Text>
        (a) Beta-Quality Testing: The basic functionality of this Beta version has been tested by
        Advizr's internal users but it has not yet undergone production quality testing. As such,
        reports of software malfunctions and bugs are fully anticipated and are solicited by Advizr.
      </Text>
      <Text>
        (b) Beta-Quality Performance: The performance of the optimization algorithms has not been
        performance-enhanced. Specifically, the current Beta version run times may exceed product
        release performance parameters for optimization runs.
      </Text>
      <Text mt="16">
        4.8 Specific Disclaimers. As the Services evolve, Advizr may provide Customer and Authorized
        Users explanations on how the Services work and certain specific disclaimers. Any such
        specific disclaimers acknowledged by any Authorized User, including through a clickwrap made
        available within the Applications Services, are agreed to be incorporated by reference into
        this Agreement. The following specific disclaimers appear within the Application Services:
      </Text>
      <Text>
        (a) No Guarantee. The recommendations above are not guarantees of investment performance or
        the full attainment of your goal. The results of this plan are based on assumptions for,
        among other things, historical investment performance, client savings rates, average
        inflation rates and estimated tax rates. In addition, investment expenses have not been
        considered in any of the calculations.
      </Text>
      <Text>
        (b) Investment Disclosures: The projected investment returns are hypothetical in nature and
        do not reflect actual investment returns in the future.
      </Text>
      <Text>
        (c) Data Integrity: The results of this plan are based, in large part, by the data that you
        have either entered into the Advizr application or provided to your financial professional.
        Any underestimations or overestimations of data entered by you could drastically change the
        recommendations made by your financial professional. It is important to update your
        financial information frequently.
      </Text>
      <Text>
        (d) Tax &amp; Legal Advice: The creation and results of this plan do not constitute legal or
        tax advice. You should consult with an attorney or an accountant for advice in those areas.
      </Text>
      <Text>
        (e) IRS Circular 230 Notice: Any tax information provided herein is not intended or written
        to be used, and cannot be used, for the purpose of avoiding penalties that may be imposed on
        any taxpayer.
      </Text>
      <Text>
        (f) Limits of financial modeling. Market volatility may be more extreme than what is
        represented by the simulation. The accuracy of the simulation is reduced in periods of
        market crisis. The simulation does not consider all investments, and those not considered
        might have characteristics similar or superior to those analyzed in this report.
      </Text>
      <Text>
        (g) Customer Future Situation: It is possible that your income, cash flow and ability to
        save may change in the future. The projections, in large part, are based on the data that
        you have provided. It is important to update your plan frequently to account for any changes
        in your financial status. Therefore, the results of this plan today cannot account for
        future changes in your financial situation.
      </Text>
      <Text>
        (h) Investment and Insurance Product Fees: Depending on what investment or insurance product
        you purchase, you may incur front-end charges, annual expenses or performance fees. For
        certain products, you may incur surrender charges, income taxes and penalties if the product
        is sold before a pre-determined period. For variable life insurance and annuity products,
        you will incur mortality and expense fees. None of these expenses have been factored into
        the projections. If included, fees and other expenses would materially reduce the
        projections.
      </Text>
      <Text mt="16">
        4.9 Disclaimer of Indirect Damages. IN NO EVENT SHALL EITHER PARTY BE LIABLE FOR ANY
        INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE OR EXEMPLARY DAMAGES, INCLUDING BUT
        NOT LIMITED TO LOSS OF PROFITS, LOSS OF DATA, LOSS OF REVENUE, LOSS OF MARKET
        CAPITALIZATION, INTERRUPTION OF SERVICE, OR LOSS OF BUSINESS OR BUSINESS OPPORTUNITY, EVEN
        IF SUCH DAMAGES ARE FORESEEABLE AND WHETHER OR NOT SUCH PARTY HAS BEEN ADVISED OF THE
        POSSIBILITY THEREOF. IN NO EVENT WILL ADVIZR BE LIABLE FOR THE PROCUREMENT OF SUBSTITUTE
        SERVICES.
      </Text>
      <Text my="16">
        4.10 Limitations on Liability. ADVIZR'S MAXIMUM AGGREGATE LIABILITY UNDER ANY ORDER FORM
        WILL NOT EXCEED THE TOTAL AMOUNT OF FEES RECEIVED BY ADVIZR'S UNDER SUCH ORDER FORM DURING
        THE TWELVE (12) MONTH PERIOD PRIOR TO THE FIRST DATE ON WHICH THE LIABILITY AROSE.
      </Text>
      <Text my="16">5. INDEMNITY.</Text>
      <Text my="16">
        5.1 Advizr Indemnity. Advizr will indemnify, defend and hold Customer, its directors,
        officers, employees and representatives (each a "Customer Indemnified Party"), harmless from
        and against any and all losses, damages, liability, costs and expenses awarded by a court or
        agreed upon in settlement, as well as all reasonable and related attorneys' fees and court
        costs, (collectively "Losses") arising out of any third party claim alleging that the
        Application Services infringe any U.S. patent or copyright or breach any Advizr warranty.
      </Text>
      <Text my="16">
        5.2 Exclusions. Section 5.1 will not apply if the alleged claim arises, in whole or in part,
        from (i) a use or modification of the Services by any Customer or any Authorized User in a
        manner outside the scope of any right granted or in breach of this Agreement, (ii) a
        combination, operation or use of the Services with other software, hardware or technology
        not provided by Advizr if the claim would not have arisen by the exclusive use of the
        Application Services alone, (iii) the Customer Data or (iv) any financial plans, advice or
        other information provided by Customer to any Advisee (any of the foregoing circumstances
        under clauses (i), (ii), (iii) or (iv) will be collectively referred to as a "Customer
        Indemnity Responsibility").
      </Text>
      <Text my="16">
        5.3 Customer Indemnity. Customer will indemnify, defend and hold harmless Advizr, its
        directors, officers, employees and representatives (each a "Advizr Indemnified Party"), from
        and against any and all Losses arising out of any third party claim alleging a Customer
        breach of any Customer warranty or arising out of any Customer Indemnity Responsibility.
      </Text>
      <Text my="16">
        5.4 Indemnification Process. The foregoing indemnification obligations are conditioned on
        the indemnified party: (a) notifying the indemnifying party promptly in writing of such
        action, (b) reasonably cooperating and assisting in such defense and (c) giving sole control
        of the defense and any related settlement negotiations to the indemnifying party with the
        understanding that the indemnifying party may not settle any claim in a manner that admits
        guilt or otherwise prejudices the indemnified party without consent.
      </Text>
      <Text my="16">
        5.5 Infringement. If any Service is, or in Advizr's opinion, is likely to become the subject
        of any infringement-related claim, then Advizr will, at its expense and in its discretion:
        (a) procure for Customer the right to continue using the Service; (b) replace or modify the
        infringing technology or material so that the Service becomes non-infringing and remains
        materially functionally equivalent; or (c) terminate the Schedule(s) pursuant to which the
        Service is provided and give Customer a refund for any pre-paid but unused fees.
      </Text>
      <Text my="16">
        5.6 THE PROVISIONS OF THIS SECTION 5 STATE ADVIZR'S ENTIRE LIABILITY AND CUSTOMER'S
        EXCLUSIVE REMEDIES FOR ANY CLAIM THAT THE SERVICES, ANY DELIVERABLE, OR THE TECHNOLOGY
        UNDERLYING ANY OF THE SERVICES, INFRINGE A THIRD PARTY'S INTELLECTUAL PROPERTY RIGHT.
      </Text>
      <Text my="16">6. CONFIDENTIAL INFORMATION.</Text>
      <Text my="16">
        6.1 Confidentiality. Each party will maintain in confidence all Confidential Information
        disclosed by the other party hereto. As used herein "Confidential Information" will mean all
        tangible information which is marked as "confidential" or "proprietary" and all information
        which is disclosed and should reasonably be considered confidential. Notwithstanding the
        foregoing, (a) the Advizr Confidential Information will include the Application Services,
        and the algorithms, know-how and technology underlying the Application Services and (b)
        Customer Confidential Information will include the Customer Data. Advizr may disclose
        Customer Confidential Information to employees, contractors and trainees who have agreed in
        writing to hold such Customer Confidential Information in confidence and not to use such
        information for any purposes other than those authorized by this Agreement. Customer may
        disclose Advizr Confidential Information to employees and contractors who are not Advizr
        competitors who have agreed in writing to hold such Advizr Confidential Information in
        confidence and not to use such information for any purpose other than those authorized by
        this Agreement. Each party will use at least the same standard of care as it uses to protect
        its own most confidential information to ensure that such employees or contractors do not
        disclose or make any unauthorized use of such Confidential Information.
      </Text>
      <Text my="16">
        6.2 Exceptions. The obligations of confidentiality contained in Paragraph 6.1
        ("Confidentiality") will not apply to the extent that it can be established by the receiving
        party ("Recipient") by competent proof that such Confidential Information: (i) was already
        known to Recipient, other than under an obligation of confidentiality, at the time of
        disclosure by the other party; (ii) was generally available to the public or otherwise part
        of the public domain at the time of its disclosure; (iii) became generally available to the
        public or otherwise part of the public domain after its disclosure other than through any
        act or omission of Recipient in breach of this Agreement; (iv) was disclosed to Recipient,
        other than under an obligation of confidentiality, by a third party who had no obligation to
        the other party not to disclose such information to others; or (v) was independently
        developed by Recipient without use of the disclosing party's Confidential Information.
      </Text>
      <Text my="16">7. PAYMENT TERMS.</Text>
      <Text my="16">
        7.1 Invoice for Professional Services. Fees for professional services will be due and
        payable in accordance with Section 7.2 ("Payment Terms") below. Except as may otherwise be
        provided in an Order Form, fees for Professional Services will be provided on a time and
        materials basis; that is, Customer will pay Advizr for the time spent performing such
        Professional Services, plus materials, taxes, and expenses. Any estimated price will be an
        estimate only for Customer's budgeting and Advizr's resource scheduling purposes.
      </Text>
      <Text my="16">
        7.2 Payment Terms. All fees will be invoiced upon execution of each Order Form by Customer.
        Payment will be due immediately upon invoice and each month's service will be paid for at
        the beginning of the month. Overdue payments will accrue interest at the lesser of 1.5% per
        month or the maximum allowable interest under applicable law, and Customer will pay Advizr's
        associated cost of collection including reasonable attorneys' fees.
      </Text>
      <Text my="16">
        7.3 Expenses. Customer will reimburse Advizr for all reasonable and customary expenses
        incurred by Advizr in providing Professional Services pursuant to this Agreement and for all
        reasonable travel and lodging expenses incurred by Advizr.
      </Text>
      <Text my="16">
        7.4 Taxes. Prices do not include taxes or duties. If Advizr is required to pay or collect
        any local, value added, goods and services taxes, or any other similar taxes or duties
        arising out of or related to this Agreement (not including taxes based on Advizr's income),
        then such taxes and/or duties will be billed to and paid by Customer.
      </Text>
      <Text my="16">8. MISCELLANEOUS</Text>
      <Text my="16">
        8.1 Reference. Customer hereby grants Advizr permission to identify Customer by name as a
        Customer of Advizr on the Advizr website and in any publicly filed document, press release
        and/or any other marketing materials.
      </Text>
      <Text my="16">
        8.2 Assignment. Neither party may assign or transfer its rights or obligations under this
        Agreement without the prior written consent of the other party, and any assignment or
        transfer in derogation of the foregoing will be null and void; provided, however, that
        Advizr will have the right to assign its rights to receivables hereunder to a bank or other
        financial institution and that either party will have the right to assign the Agreement,
        without the prior written consent of the other party, to the successor entity in the event
        of merger, corporate reorganization or a sale of all or substantially all of its assets. The
        terms of this Agreement will be binding upon such assignees.
      </Text>
      <Text my="16">
        8.3 Force Majeure. Neither party will be liable to the other under this Agreement for any
        delay or lack of performance (other than nonpayment) resulting from a Force Majeure event.
        "Force Majeure" event means any act of God, war, fire, typhoon, flood, earthquake, natural
        disasters, governmental action, labor disruptions, materials shortages, or any other event
        beyond the reasonable control of the prevented party.
      </Text>
      <Text my="16">
        8.4 Notices. All notices and other communications provided for hereunder will be in writing
        and will be required to be delivered by email (but solely to the extent that an email
        address is provided in the Cover Page) and one of the following additional means: personal
        delivery, overnight courier, confirmed facsimile, or certified or registered mail, return
        receipt requested. Notices will be sent to the parties using the notice information provided
        in the Cover Page, or to such other address as that party may specify in writing pursuant to
        this section.
      </Text>
      <Text my="16">
        8.5 Governing Law. All matters arising in connection with this Agreement or the enforcement
        or construction thereof will be governed by and resolved in accordance with the laws of the
        State of New York without reference to its conflicts of laws principles or any other
        principles that would result in the application of a different body of law. For any claim
        arising from or related to this Agreement, each party hereby expressly consents to exclusive
        jurisdiction and venue of the state or federal courts located in the County of New York.
      </Text>
      <Text my="16">
        8.6 Independent Contractors. The parties hereto are independent contractors and this
        Agreement will not be construed as creating any joint venture, partnership or other like
        relationship.
      </Text>
      <Text my="16">
        8.7 Waiver. No provision of this Agreement, unless such provision otherwise provides, will
        be waived by any act, omission or knowledge of a party or its agents or employees except by
        an instrument in writing expressly waiving such provision and signed by a duly authorized
        officer of the waiving party.
      </Text>
      <Text my="16">
        8.8 Severability. If any provision of this Agreement is unenforceable or illegal, such
        provision will be changed and interpreted to accomplish the objectives of such provision to
        the greatest extent possible under applicable law and the remaining provisions will continue
        in full force and effect.
      </Text>
      <Text my="16">
        8.9 Counterparts; Electronic Signatures. This Agreement may be executed in two or more
        counterparts, anyone of which need not contain the signatures of more than one party, but
        all such counterparts taken together will constitute one and the same agreement. Delivery of
        an executed counterpart of a signature page to this Agreement by electronic means (including
        by PDF or facsimile) will be effective as delivery of a mutually executed counterpart to
        this Agreement.
      </Text>
      <Text my="16">
        8.10 Entire Agreement. This Agreement, together with the exhibits attached hereto,
        constitute the entire agreement between the parties and supersede all prior oral or written
        negotiations and agreements between the parties with respect to the subject matter hereof.
        In the event of any conflict between this Agreement and any statement of work, the terms of
        this Agreement will control. No modification, variation or amendment of this Agreement will
        be effective unless made in writing and signed by the parties. Purchase orders provided by
        Customer, including any terms and conditions contained therein, will be for administrative
        purposes only and will have no force or effect.
      </Text>
    </Box>
    <Button size="large" onClick={onSave}>
      I Agree
    </Button>
  </Box>
);
